import React, { useEffect } from "react";
import { ArrowBack, Check, Close } from "@mui/icons-material";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import { listPmsUpdateDetails, resetPmsUpdateDetails } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useTheme } from "@emotion/react";
import { tokens } from "../../theme";
import moment from "moment";

function PmsUpdateDetails() {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const { pmsUpdateDetails } = useSelector(
        ({
            pms: { pmsUpdateDetails },
        }) => ({
            pmsUpdateDetails,
        })
    );

    useEffect(() => {
        document.title = 'PMS Update Details';
        dispatch(resetPmsUpdateDetails());
        fetchMoreData();
        // eslint-disable-next-line
    }, [dispatch, id]);

    const fetchMoreData = () => {
        dispatch(listPmsUpdateDetails({ id: id }));
    }

    const KeyAndValue = ({ keyName, value, render }) => (
        <Grid item md={6} xs={12}>
            <Stack direction="row" spacing={2}>
                <Typography width={"40%"}>{keyName}:</Typography>
                {value ?
                <Typography>
                    {value}
                </Typography>
                : render }
            </Stack>
        </Grid>
    )

    return (
        <Box m="20px" mb={15}>
            <Stack
                direction={"row"}
                justifyContent={"space-between"}
                alignItems={"flex-end"}
                spacing={2}
                m="20px 0"
            >
                <Button size="small" variant="outlined" onClick={() => navigate(-1)}>
                    <ArrowBack fontSize="small" />
                </Button>
                <Typography fontWeight="bold" variant="h4">
                    PMS UPDATE DETAILS
                </Typography>
                <Box width={40} />
            </Stack>
            <Box
                width="100%"
                p={2}
                borderRadius={1}
                backgroundColor={colors.primary[400]}
            >
                <Grid container rowSpacing={2} columnSpacing={4}>
                    <KeyAndValue keyName={"Start date"} value={pmsUpdateDetails?.start_date || "-"}/>
                    <KeyAndValue keyName={"End date"} value={pmsUpdateDetails?.end_date || "-"}/>
                    <KeyAndValue keyName={"PMS count"} value={pmsUpdateDetails?.avail_count ?? "-"}/>
                    <KeyAndValue keyName={"Stop sell"} render={pmsUpdateDetails?.stop_sell ? <Check color="success"/> : <Close color="error"/>}/>
                    <KeyAndValue keyName={"Travelnet count"} value={pmsUpdateDetails?.cron_avail_count ?? "-"}/>
                    <KeyAndValue keyName={"Travelnet updated at"} value={pmsUpdateDetails?.cron_updated_at ? moment.unix(pmsUpdateDetails?.cron_updated_at).format("DD-MM-YYYY - HH:mm") : "-"}/>
                    <KeyAndValue keyName={"Created at"} value={pmsUpdateDetails?.created_at ? moment.unix(pmsUpdateDetails?.created_at).format("DD-MM-YYYY - HH:mm") : "-"}/>
                    <KeyAndValue keyName={"Updated at"} value={pmsUpdateDetails?.updated_at ? moment.unix(pmsUpdateDetails?.updated_at).format("DD-MM-YYYY - HH:mm") : "-"}/>
                    <KeyAndValue keyName={"PMS hotel id"} value={pmsUpdateDetails?.pms_hotel_id || "-"}/>
                    <KeyAndValue keyName={"PMS room id"} value={pmsUpdateDetails?.pms_room_id || "-"}/>
                    <KeyAndValue keyName={"Roomtype"} value={pmsUpdateDetails?.roomtype_id?.name || "-"}/>
                </Grid>
            </Box>
        </Box>
    );
}

export default PmsUpdateDetails;
